<template>
    <div>
        <div class="nav-tabs_parent">
            <ul class="nav nav-tabs" id="navbar-list">
                <li class="nav-item" 
                    :class="{active:getTabSelected.tabIndex===key, 'border-left': key === 0}" 
                    v-for="(tab,key) in tabs" :key="key">
                    <a href="#" class="nav-link" @click="selectTabMethod(key)">
                        {{tab.type}}
                    </a>
                </li>
            </ul>    
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
    data:function(){
        return {
            tabs: [
                {tabIndex: 0, type: 'Spot', link:"/sellerDashboard/spot"}, 
                {tabIndex: 1, type: 'Contracts', link:"/sellerDashboard/contract"}, 
                {tabIndex: 2, type: 'Delivered In', link:"/sellerDashboard/deliveredIn"}
            ]
        }
    },
    created() {
        if (this.$router.history.current.params.tab==="spot"){
            this.selectTab(this.tabs[0])
        }else if (this.$router.history.current.params.tab==="contract"){
            this.selectTab(this.tabs[1])
        }else if (this.$router.history.current.params.tab==="deliveredIn"){
            this.selectTab(this.tabs[2])
        }else{
            this.selectTab(this.tabs[0])
        } 
    },
    computed: {
        ...mapGetters('sellerDashboard', ['getTabSelected'])
    },
    methods:{
        ...mapActions('sellerDashboard',['selectTab']),
        selectTabMethod(tabkey){
            if (event){
                event.preventDefault()
            }
            this.$router.push(this.tabs[tabkey].link)
            this.selectTab(this.tabs[tabkey])
        }
    }
}
</script>